import { Capacitor } from '@capacitor/core';

// Get API URL from environment variable
// This must be set in your .env file or build configuration
const getApiBaseUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL;
  
  if (!apiUrl) {
    const platform = Capacitor.isNativePlatform() ? Capacitor.getPlatform() : 'web';
    const errorMessage = 
      `VITE_API_URL environment variable is not set for ${platform} platform. ` +
      'Please configure it in your .env file or build configuration.';

    throw new Error(errorMessage);
  }
  
  
  // Warn if using localhost on native platforms (might indicate misconfiguration)
  if (Capacitor.isNativePlatform() && apiUrl.includes('localhost')) {
    console.warn(
      '⚠️ Using localhost API URL on native platform. ' +
      'Make sure your backend at this URL has Firebase credentials configured, ' +
      'or set VITE_API_URL to point to a backend that has them configured.'
    );
  }
  
  return apiUrl;
};

export const ApiConfig = {
    baseUrl: getApiBaseUrl(),
    getHeaders: (token?: string) => {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
      };
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      return headers;
    }
  };